var map = {
	"./bbc54yyk/login_bg.jpg": 932,
	"./chaoxinxing/login_bg.jpg": 934,
	"./ecshopx/login_bg.jpg": 936,
	"./onex/login_bg.jpg": 943,
	"./yyk/login_bg.jpg": 945
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 107;


//////////////////
// WEBPACK FOOTER
// ./static/img ^\.\/.*\/login_bg\.jpg$
// module id = 107
// module chunks = 30